import { useGroupedByCategory } from '../hooks/useGroupedByCategory';
import { useDynamicColumnCount } from '../hooks/useDynamicColumnCount';
import { ShoppingListCategory } from './ShoppingListCategory';
import { Box } from '@mui/joy';

export function ShoppingListItems({ items, isEntryChecked, onToggle, crossOffSelected, showRecipeSources = false }) {
  const groupedByCategory = useGroupedByCategory(items);
  const { containerRef, columnCount } = useDynamicColumnCount({ breakpoints: [800, 1200], columns: [1, 2, 3] });

  return (
    <Box
      ref={containerRef}
      sx={{
        columnCount: columnCount,
        columnGap: 3,
        '& > *': {
          breakInside: 'avoid',
          pageBreakInside: 'avoid',
          marginBottom: 2,
        },
      }}
    >
      {groupedByCategory.map(({ category, entries }) => (
        <ShoppingListCategory key={category.name} category={category} entries={entries} isEntryChecked={isEntryChecked} onToggle={onToggle} crossOffSelected={crossOffSelected} showRecipeSources={showRecipeSources} />
      ))}
    </Box>
  );
}